<template>
    <div>
        <div class="title-nav">
            <div class="weui-cells__title">
                <p style="font-size: 20px; color: #fff">业务统计</p>
                <p style="color: #fff">{{ dateStr }}</p>
            </div>
        </div>
        <div class="weui-cells">
            <div class="item" v-for="item in results" :key="item._id">
                <div class="type-label">{{ _formatType(item.type) }}：</div>
                <div class="detail" v-for="subItem in item.detail" :key="subItem._id">
                    <span>{{ subItem.name }}，数量：{{ subItem.count }}</span>
                    <span v-if="subItem.money != '-'">，金额：{{ subItem.money }}</span>
                </div>
            </div>
        </div>
        <div class="weui-footer">
            <p class="weui-footer__links">
                <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
            </p>
            <p class="weui-footer__text">Copyright &copy; 2017-{{ year }} aixyt.com</p>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import weui from "weui.js";
import moment from "moment";

export default {
    data() {
        return {
            dateStr: "",
            year: moment().format("YYYY"),
            results: []
        };
    },
    created() {
        this.dateStr = this.$route.params.date;
        axios.defaults.headers["Authorization"] = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiJ4eXQiLCJpYXQiOjE2NDc2MDgyNjh9.UHMy6jkQIrwJcyzzVgghLLYCQtAXQycyzWqCZI7luPE";

        let loading = weui.loading("数据加载中", {
            className: "custom-classname"
        });

        axios
            .get("/api/statistics/daily/" + this.dateStr)
            .then(res => {
                if (res.data.success) {
                    loading.hide(function () { });
                    this.results = res.data.data;
                    console.log(this.results);
                } else {
                    weui.toast(res.data.message, 2000);
                }
            })
            .catch(err => {
                loading.hide(function () { });
                weui.toast(err, 2000);
            });
    },
    methods: {
        _formatType(type) {
            let typeStr = "";
            switch (type) {
                case 1:
                    typeStr = "外卖量统计";
                    break;
                case 2:
                    typeStr = "快递量统计";
                    break;
                case 3:
                    typeStr = "外卖柜统计";
                    break;
                case 4:
                    typeStr = "跑腿量统计";
                    break;
                case 5:
                    typeStr = "绑定量统计";
                    break;
                case 6:
                    typeStr = "短信量统计";
                    break;
                default:
                    typeStr = "未知"
            }
            return typeStr;
        }
    }
};
</script>

<style scoped>
.title-nav {
    position: absolute;
    height: 90px;
    width: 100%;
    background-color: #1aad19;
    top: 0px;
    color: #fff;
}

.weui-cells {
    margin-top: 90px;
}

.weui-cells__title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: gray;
    margin-bottom: 0px;
}

.item {
    padding: 15px;
    margin: 15px;
    border: 1px solid #E4E7ED;
}

.type-label {
    font-size: 18px;
    font-weight: bold;
}

.detail {
    margin: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #E4E7ED;
}

.detail:last-child {
    margin-bottom: 0px;
    padding-bottom: 0px;
    border-bottom: none;
}

.weui-footer {
    margin-top: 15px;
    margin-bottom: 10px;
    left: 0px;
    right: 0px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/infos/DailyStatic.vue